export const SPACE_BETWEEN_ELEMENTS = 36.4;
export const STARTING_Y = 14;
export const RADIUS = 6;
export const SPACE_BETWEEN_VLINES = 20;
export const DEFAULT_PROCESS_FLOW_WIDTH = 199; // This is good with DEFAULT_SPACE_BETWEEN_VLINES

// get default shape form to be used
export function getCircle(elementIndex) {
  const y = STARTING_Y + SPACE_BETWEEN_ELEMENTS * elementIndex;
  const circle = {
    cx: SPACE_BETWEEN_VLINES,
    cy: y,
  };
  return circle;
}
// get default connection between two elements
export function getConnection(shape1, shape2, offset) {
  const shape1X = shape1.attributes.cx;
  const shape1Y = shape1.attributes.cy;
  const shape2X = shape2.attributes.cx;
  const shape2Y = shape2.attributes.cy;

  const answer = [];

  if (Math.abs(shape1X - shape2X) < RADIUS) {
    return getStraightLine(shape1, shape2, offset);
  } else if (shape1X < shape2X) {
    if (shape1Y < shape2Y) {
      return [
        getShapeRightPoint(shape1),
        [shape2X, shape1Y],
        reducePointY(getShapeTopPoint(shape2)),
        getShapeTopPoint(shape2),
      ];
    } else {
      return [
        getShapeRightPoint(shape1),
        [shape2X, shape1Y],
        increasePointY(getShapeBottomPoint(shape2)),
        getShapeBottomPoint(shape2),
      ];
    }
  } else {
    if (shape1Y < shape2Y) {
      return [
        getShapeLeftPoint(shape1),
        [shape2X, shape1Y],
        reducePointY(getShapeTopPoint(shape2)),
        getShapeTopPoint(shape2),
      ];
    } else {
      return [
        getShapeLeftPoint(shape1),
        [shape2X, shape1Y],
        increasePointY(getShapeBottomPoint(shape2)),
        getShapeBottomPoint(shape2),
      ];
    }
  }
}

export function getStraightLine(shape1, shape2, offset) {
  const shape1X = shape1.attributes.cx;
  const shape1Y = shape1.attributes.cy;
  const shape2X = shape2.attributes.cx;
  const shape2Y = shape2.attributes.cy;

  if (shape1Y < shape2Y) {
    if (offset) {
      // y = 2x-1
      const offsetX = (2 * offset - 1) * (SPACE_BETWEEN_VLINES / 2);
      return [
        getShapeRightPoint(shape1),
        getShapeRightPoint(shape1, offsetX),
        getShapeRightPoint(shape2, offsetX),
        getShapeRightPoint(shape2),
      ];
    }
    return [
      getShapeBottomPoint(shape1),
      getShapeBottomPoint(shape1),
      reducePointY(getShapeTopPoint(shape2)),
      getShapeTopPoint(shape2),
    ];
  } else {
    if (offset) {
      const offsetX = (2 * offset - 1) * (SPACE_BETWEEN_VLINES / 2);
      return [
        getShapeRightPoint(shape1),
        getShapeRightPoint(shape1, offsetX),
        getShapeRightPoint(shape2, offsetX),
        getShapeRightPoint(shape2),
      ];
    }
    return [
      getShapeTopPoint(shape1),
      getShapeTopPoint(shape1),
      increasePointY(getShapeBottomPoint(shape2)),
      getShapeBottomPoint(shape2),
    ];
  }
}

// necessary for making arrow head right
function reducePointY(point) {
  return [point[0], point[1] - 1];
}
function increasePointY(point) {
  return [point[0], point[1] + 1];
}
function reducePointX(point) {
  return [point[0] - 1, point[1]];
}
function increasePointX(point) {
  return [point[0] + 1, point[1]];
}
function getShapeTopPoint(shape) {
  return [shape.attributes.cx, shape.attributes.cy - RADIUS];
}
function getShapeRightPoint(shape, offsetX = 0) {
  let cx = offsetX ? shape.attributes.cx + offsetX : shape.attributes.cx + RADIUS;

  return [cx, shape.attributes.cy];
}
function getShapeBottomPoint(shape) {
  return [shape.attributes.cx, shape.attributes.cy + RADIUS];
}
function getShapeLeftPoint(shape) {
  return [shape.attributes.cx - RADIUS, shape.attributes.cy];
}
// getVerticalPoints
// getBestXPosition
// getStraightLine

// getNonStraightLine()

// getTopBottom
// getBottomUp

// calculate the points for shape V based on a circle
export function getOrPoints(cx, cy, radius = RADIUS) {
  const diff = radius / Math.sqrt(2);

  const x1 = parseInt(cx - diff);
  const y1 = parseInt(cy - diff);

  const x2 = cx;
  const y2 = cy + radius - 3;

  const x3 = parseInt(cx + diff);
  const y3 = parseInt(cy - diff);

  return `${x1} ${y1} ${x2} ${y2} ${x3} ${y3}`;
}

export function getAndPoints(cx, cy, radius = RADIUS) {
  const diff = radius / Math.sqrt(2);

  const x1 = parseInt(cx - diff);
  const y1 = parseInt(cy + diff);

  const x2 = cx;
  const y2 = cy - radius + 3;

  const x3 = parseInt(cx + diff);
  const y3 = parseInt(cy + diff);

  return `${x1} ${y1} ${x2} ${y2} ${x3} ${y3}`;
}

export function getXorPoints(cx, cy, radius = RADIUS) {
  const diff = radius / Math.sqrt(2);
  const vPoints = getOrPoints(cx, cy, radius).split(" ");

  const x1 = parseInt(cx - diff);
  const y1 = cy + radius - 3;

  const x2 = cx;
  const y2 = cy + radius - 3;

  const x3 = parseInt(cx + diff);
  const y3 = cy + radius - 3;

  const newPoints = [...vPoints.slice(0, 4), x1, y1, x2, y2, x3, y3, ...vPoints.slice(2)];
  return newPoints.join(" ");
}
